import { useQuery } from '@tanstack/react-query'
import { sessionQueryOptions } from '../api/queries'
import type { Session } from '../model/schema'

interface UseSessionResult {
  session: Session | null
  isPending: boolean
  isCustomer: boolean
}

// Кто смотрит. Пока сессия грузится, isCustomer = false: витрина заказчика
// открывается по факту, а не «на всякий случай».
export function useSession(): UseSessionResult {
  const { data, isPending } = useQuery(sessionQueryOptions)
  return {
    session: data ?? null,
    isPending,
    isCustomer: data?.kind === 'customer',
  }
}
